import React, { useState } from "react";
import { isDesktop } from "react-device-detect";
import classNames from "classnames";
import _get from "lodash-es/get";

import Form from "src/bepaid/components/Form";
import Radio from "antd/es/radio";
import Space from "antd/es/space";

import InputText from "src/bepaid/components/Form/controls/InputText";
import FormStyles from "src/bepaid/components/Form/CommonForm.module.scss";
import Button from "src/bepaid/components/Form/controls/Button";

import styles from "../Additional.module.scss";

const Component = (props: any) => {
  const { form, changeGenerateInvoiceNumber, otherSetting, submit } = props;
  const commonFormItemProps = {
    reserveValueOnUnmount: true,
    revertValueOnMount: true
  };
  const [typeInvoice, setTypeInvoice] = useState(
    _get(otherSetting, "generateOrManualIN")
  );
  const handleChangeSelectTypeInvoice = (e: any) => {
    setTypeInvoice(e.target.value);
    changeGenerateInvoiceNumber(e.target.value);
    props.setControl({
      errors: [],
      form: props.form,
      name: `to_generate_or_add_manual_invoice_number`,
      value: e.target.value
    });
  };
  const handleSubmitInvoiceNumber = () => {
    submit();
  };
  return (
    <div
      className={classNames(FormStyles.content, styles.wrapperDetailsContent, {
        [styles.desktopDetailContent]: isDesktop
      })}
    >
      <div>
        <p className={styles.textTitle}>
          How to you want to generate your invoice number?
        </p>
        <Form
          layout="vertical"
          requiredMark={false}
          className={classNames(
            FormStyles.personalFormDetail,
            styles.formInput,
            {
              [styles.formInputDesktop]: isDesktop
            }
          )}
        >
          <Radio.Group
            onChange={handleChangeSelectTypeInvoice}
            defaultValue={typeInvoice}
          >
            <Space direction="vertical">
              <Radio
                value={"generate"}
                name="to_generate_or_add_manual_invoice_number"
              >
                <div className={styles.titles}>
                  Use auto-generated invoice number
                </div>
              </Radio>
              {typeInvoice === "generate" && (
                <div className={styles.counter}>
                  <InputText
                    hidden={true}
                    className={styles.hidden}
                    form={form}
                    name={`to_generate_or_add_manual_invoice_number`}
                    defaultValue={_get(otherSetting, "generateOrManualIN")}
                    {...commonFormItemProps}
                  />
                  <InputText
                    form={form}
                    label={"Prefix"}
                    name={`invoice_number_prefix`}
                    defaultValue={_get(otherSetting, "invoiceNumberPrefix")}
                    placeholder={"eg: INV-"}
                    {...commonFormItemProps}
                  />
                  <InputText
                    form={form}
                    label={"Next Number"}
                    name={`invoice_number_template`}
                    defaultValue={_get(otherSetting, "invoiceNumberTemplate")}
                    placeholder={"Next invoice number"}
                    {...commonFormItemProps}
                  />
                </div>
              )}
              <Radio value={"manual"}>
                <div className={styles.titles}>
                  Add invoice number manually every time
                </div>
              </Radio>
            </Space>
          </Radio.Group>
        </Form>
      </div>
      <div>
        <Button
          type="primary"
          htmlType="submit"
          onClick={handleSubmitInvoiceNumber}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default Component;
